export default __webpack_public_path__ + "static/media/plus.a1f2c74b.png";